<template>
  <div class="card-box">
    <div class="card-box_title">
      <span>友情链接</span>
    </div>
    <div class="card-box_container">
      <a
        v-for="item in dataList"
        :key="item.name"
        :href="item.link"
        target="_blank"
        >{{ item.name }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataList: [
        {
          name: '中国烹饪协会',
          link: 'http://www.ccas.com.cn/',
        },
        {
          name: '中国饭店协会',
          link: 'http://www.chinahotel.org.cn/',
        },
        {
          name: '吉林省人力资源和社会保障厅',
          link: 'http://hrss.jl.gov.cn/',
        },
        {
          name: '吉林省商务厅',
          link: 'http://swt.jl.gov.cn/',
        },
        {
          name: '长春市商务局',
          link: 'http://swj.changchun.gov.cn/',
        },
        {
          name: '长春市文化广播电视和旅游局',
          link: 'http://wglj.changchun.gov.cn/',
        },
        {
          name: '西藏自治区烹饪餐饮饭店业协会',
          link: 'http://www.tibetcook.com/',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.card-box {
  width: 100%;
  margin-bottom: 10px;
  &_title {
    height: 30px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    border-bottom: 4px solid #ebebeb;
    span {
      text-align: center;
      font-weight: normal;
      font-size: 18px;
      height: 30px;
      border-bottom: 4px solid #d9251e;
    }
  }
  &_container {
    display: flex;
    justify-content: space-between;
    a {
      border: 0;
      text-decoration: none;
      color: #333;
      font-size: 14px;
      &:active,
      &:hover,
      &:link,
      &:visited {
        border: 0;
        text-decoration: none;
        color: #333;
      }
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
